import styles from './Placeholder.module.css'

/**
 * A screen that exists in the navigation but not yet in the product. It states
 * plainly what will live here rather than pretending to be broken — the
 * navigation shell is what Phase 1 delivers, and this is honest about that.
 */
export function Placeholder({ title, text }: { title: string; text: string }) {
  return (
    <div className={styles.screen}>
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.text}>{text}</p>
    </div>
  )
}
